/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
// import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Autocomplete, RenderInputParams } from '@material-ui/lab';
import { TextField, CircularProgress, makeStyles, Theme, createStyles } from '@material-ui/core';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { FetchPolicy } from 'apollo-client';
import gql from 'graphql-tag';
import { client } from '../..';
import { IAutoCompleteItem } from '../../typings/autoComplete';
import { showNotification } from '../../App';
import { FirmData, Team } from '../models/Firm';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
        minWidth: '200px',
    },
  })
);

export interface TeamQueryParams {
    isMyTeamOnly: boolean | null;
    onlyUsedByTasks: boolean | null;
    onlyUsedByEnquiries: boolean | null;
    onlyUsedByFinancials: boolean | null;
}

interface FirmTeamSelectorProps {
    disabled?: boolean;
    required?: boolean;
    multiple?: boolean;
    // tslint:disable-next-line: no-any
    value?: IAutoCompleteItem | any; // value only available in single select
    error?: boolean;
    onSelection?: (value: IAutoCompleteItem | IAutoCompleteItem[], name?: string) => void;
    className?: string;
    helperText?: string;
    name?: string;
    label?: string;
    style?: React.CSSProperties; 
    disablePortal?: boolean;
    isMyTeamOnly: boolean | null;
    enquiryOnly: boolean | null;
    financialOnly: boolean | null;
    taskOnly: boolean | null;
    isRefresh?: boolean;
    /** Reports this selector's own loading state — use to surface a loading indicator elsewhere (e.g. the advanced filter toggle) without blocking the rest of the page */
    onLoadingChange?: (isLoading: boolean) => void;
    variant?: 'outlined' | 'filled' | 'standard';
    size?: 'small' | 'medium';
}

interface FirmTeamSelectorState {
    isLoading: boolean;
    data: IAutoCompleteItem[];
}

export const FirmTeamSelector: React.FC<FirmTeamSelectorProps> = props => {

    const classes = useStyles();

    const [state, setState] = useState<FirmTeamSelectorState>({
        isLoading: false,
        data: [],
    });

    useEffect(() => {   
        fetchData();
    // tslint:disable-next-line: align
    }, []);

    const fetchData = () => {

        setState({
            ...state,
            isLoading: true
        });
        props.onLoadingChange?.(true);

        let query: TeamQueryParams = {
            isMyTeamOnly : props.isMyTeamOnly,
            onlyUsedByTasks: props.taskOnly,
            onlyUsedByFinancials: props.financialOnly,
            onlyUsedByEnquiries: props.enquiryOnly
            
                // UserFeature.HasAccess(UserFeatureEnum.hasFirmDashboardTeamView) 
                //             ? null
                //             : UserFeature.HasAccess(UserFeatureEnum.hasFirmDashboardMyTeamOnly)
        };

        retrieveTeamData(
            query,
            props.isRefresh ?? true,
            // tslint:disable-next-line: no-console
            (data) => onRetrieveData(data),
            // tslint:disable-next-line:no-any
            function (reason: any): void {
                showNotification(null, reason, 'error');
                props.onLoadingChange?.(false);
            }
        );
    };

    const onRetrieveData = (data: FirmData) => {
        setState({
            ...state,
            data: data.firm.teams.team.map((source: Team) => ({value: source.guidID, label: source.description })),
            isLoading: false
        });
        props.onLoadingChange?.(false);
    };

    // tslint:disable-next-line: no-any
    const handleChange = (event: React.ChangeEvent<{}>, value: any) => {
        if (props.onSelection) {
            props.onSelection(value, props.name);
        }
    };

    const getInputProps = (params: RenderInputParams, isLoading?: boolean) => {
        return  ({   
            ...params.InputProps,
            endAdornment: (
                <React.Fragment>
                  {isLoading ? <CircularProgress color="primary" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),     
         });
    };

    return (
        <div className={`${classes.root} ${props.className}`}>
            { props.multiple ? 
                (
                    <Autocomplete
                        style={props.style}
                        className={props.className}
                        value={props.value}
                        multiple={true}
                        loading={state.isLoading}
                        disabled={props.disabled}
                        onChange={handleChange}
                        options={state.data}
                        disablePortal={props.disablePortal} // to Stop the dropdown select from closing the form
                        // tslint:disable-next-line: jsx-no-lambda
                        getOptionLabel={(option: IAutoCompleteItem) => option.label}        
                        size={props.size ? props.size : 'medium'}
                        ChipProps={{
                            size: props.size ?? 'medium'
                        }}            
                        // tslint:disable-next-line: jsx-no-lambda
                        renderInput={params => (
                            <TextField 
                                {...params} 
                                label={props.label}
                                variant={props.variant ? props.variant : 'standard'}
                                size={props.size ? props.size : 'medium'} 
                                fullWidth={true} 
                                margin="none" 
                                required={props.required}
                                InputProps={getInputProps(params, state.isLoading)}
                                error={props.error}      
                                helperText={props.helperText}                      
                            />
                        )}
                        // tslint:disable-next-line: jsx-no-lambda
                        renderOption={(option, { inputValue }) => {
                            const matches = match(option.label, inputValue);
                            const parts = parse(option.label, matches);
                    
                            return (
                                <div>
                                    {parts.map((part, index) => (
                                        <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                            {part.text}
                                        </span>
                                    ))}
                                </div>
                            );
                        }}
                    />
                )
                :
                (
                    <Autocomplete
                        style={props.style}
                        className={props.className}
                        value={props.value}
                        loading={state.isLoading}
                        disabled={props.disabled}
                        onChange={handleChange}
                        options={state.data}
                        disablePortal={props.disablePortal} // to Stop the dropdown select from closing the form
                        // tslint:disable-next-line: jsx-no-lambda
                        getOptionLabel={(option: IAutoCompleteItem) => option.label}      
                        size={props.size ? props.size : 'medium'}   
                        // tslint:disable-next-line: jsx-no-lambda
                        renderInput={params => (
                            <TextField 
                                {...params} 
                                label={props.label}
                                variant={props.variant ? props.variant : 'standard'}
                                size={props.size ? props.size : 'medium'} 
                                fullWidth={true} 
                                margin="none" 
                                required={props.required}
                                InputProps={getInputProps(params, state.isLoading)}
                                error={props.error}                            
                            />
                        )}
                        // tslint:disable-next-line: jsx-no-lambda
                        renderOption={(option, { inputValue }) => {
                            const matches = match(option.label, inputValue);
                            const parts = parse(option.label, matches);
                    
                            return (
                                <div>
                                {parts.map((part, index) => (
                                    <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                    {part.text}
                                    </span>
                                ))}
                                </div>
                            );
                        }}
                    />
                )
            }
         </div>
    );
};

export function retrieveTeamData(
    query: TeamQueryParams | undefined,
    refreshData: boolean,
    onSuccess: (data: FirmData) => void,
    // tslint:disable-next-line:no-any
    onError: (reason: any) => void
): void {
    var fetchPolicy: FetchPolicy = refreshData === true ? 'network-only' : 'cache-first';
    client
        .query({
            query: FirmTeamList,
            variables: {
                isMyTeamOnly: query ? query.isMyTeamOnly : null,
                onlyUsedByTasks: query ? query.onlyUsedByTasks : null,
                onlyUsedByEnquiries: query ? query.onlyUsedByEnquiries : null,
                onlyUsedByFinancials: query ? query.onlyUsedByFinancials : null
            
            },
            fetchPolicy: fetchPolicy,
        })
        // tslint:disable-next-line:no-any
        .then((results: { data: any }) => {
            onSuccess(results.data);
        })
        // tslint:disable-next-line:no-any
        .catch((reason: any) => {
            onError(reason);
        });
}

const FirmTeamList = gql`
query firmTeamData($isMyTeamOnly: Boolean, $onlyUsedByTasks: Boolean, $onlyUsedByEnquiries: Boolean, $onlyUsedByFinancials: Boolean) {
    firm{
        teams(isMyTeamOnly: $isMyTeamOnly, 
              onlyUsedByTasks: $onlyUsedByTasks, onlyUsedByEnquiries: $onlyUsedByEnquiries, onlyUsedByFinancials: $onlyUsedByFinancials){
            recordCount,
            team{
                guidID,
                description,
                staffCount,
                usedByEnquiries
                usedByFinancials
                usedByTasks
            }
        }
    }
}`;